import { ComplianceAppController } from '../controller/ComplianceAppController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class ComplianceAppWebComponent extends BaseWebComponentElement {
  private _companyId: string;
  private _complianceStandard: string;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ComplianceAppController,
    });
  }

  get currentCompanyId(): string {
    return this._companyId ?? Application.Main.getUserCompany()?.id;
  }

  set currentCompanyId(value: string) {
    this._companyId = value;
  }

  get currentComplianceStandard(): string {
    return this._complianceStandard;
  }

  set currentComplianceStandard(value: string) {
    this._complianceStandard = value;
  }
}
